<template>
<el-row id="mat">
    <el-col :md="13" class="material">
      <h1>Materiales de Consulta</h1>
    </el-col>
  </el-row>
    <!--<el-row >
      <h1 >Materiales de Consulta disponibles próximamente</h1>

    </el-row>
    -->
   <el-row  style="margin-bottom:40px">
      <el-carousel  autoplay=false interval=1000000 arrow="always" height="700px" >
        <el-carousel-item v-for="item in shortArray" :key="item">
           <el-col :xl="9" :md="6" :sm="12" :xs="24" v-for=" card in item" :key="card.titulo">
            <img class="iconolink" src="@/assets/link.png" v-if="card.tipo=='Link'" alt="">
            <img class="icono" src="@/assets/video.png" v-else-if="card.tipo=='Video' || card.tipo =='Imagen'" alt="">
            <img class="icono" src="@/assets/pdf.png" v-else-if="card.tipo=='PDF'" alt="">
        <div class=" cards"   >
            <h6 class="titulo">{{card.titulo}}</h6>
            <p class="contexto">{{card.descripcion}}</p>
        </div>
        <button class="enlace"  v-if="card.tipo=='Link'"><a target="_blank" :href="card.link">Abir Enlace</a> </button>
        <button class="enlace"  @click="video(card.link, card.tipo)"  v-if="card.tipo=='Video'">Ver Video </button>
        <button class="enlace"  v-if="card.tipo=='PDF'"><a target="_blank" :href="card.link" download> Descargar</a> </button>
        <button class="enlace"  @click="video(card.link, card.tipo)"  v-if="card.tipo=='Imagen'">Ver Imagen </button>
        
        </el-col>
         </el-carousel-item>
  </el-carousel>
    </el-row>
 <Video :link="link" :tipo="tipo" v-if="showVideo" />
</template>
<script>
import { ref, computed, onMounted } from "vue";
import { useStore } from "vuex";
import Video from "@/components/home/video.vue";
// import Carousel from "@/components/home/Carousel.vue";
export default {
  components: {
    Video,
  },
  props:['elemental'],
  setup(props) {
    
    const store = useStore()
    const xx = ref(null)
    
    const shortArray = ref([])
    const shorterArray = ref([])
    const link = ref()
    const tipo =ref()
    const cuatro =computed(() => (props.elemental.length))
    console.log(props)
    let getWidth = () =>{
          xx.value = screen.width
    }
    const empty = ref(null)

    window.addEventListener("load",getWidth)
      onMounted(()=>{
      smaller()
      })
    const smaller = () => {
      console.log(screen.width+'smalller')
         if (screen.width > 768)
        {
            for(let i=0;i < props.elemental.length;i+=8 ){
              shortArray.value.push(props.elemental.slice(i, i + 8))
              checker()
            }
            
        }
        else{
          for(let i=0;i < props.elemental.length;i+=4 ){
            shortArray.value.push(props.elemental.slice(i, i + 4))
            checker()
          }
        }
        }
        const checker = () =>{       
          if(props.elemental.length === 0){
             empty.value = true
          }else{
            empty.value = false
          }
         }
    console.log(shorterArray)
    console.log(empty.value +"vaciooo")
    const showVideo = computed(() => store.state.showVideo)
      
  
   const video = (l,t) =>{
     store.commit("video")
     link.value = l
     tipo.value = t
   } 
    return {
      showVideo,
      video,
      cuatro,
      shortArray,
      smaller,
      getWidth,
      link,xx,
      tipo,empty,
      checker
    }
  }
}
</script>
<style lang="scss" scoped>
#mat{
  margin-top: 75px;
}
.material h1 {
  font-family: "Yusei-Magic";
  font-size: 48px;
  color: #005d45;
  margin-bottom: 30px;
  font-weight: 300;
}
.icono {
  height: 140px;
  width: 120px;
  background-color: transparent;
  margin-right: 170px;
  margin-bottom: -140px;
}

.iconolink {
  
  height: 105px;
  widows: 105px;
  background-color: transparent;
  margin-right: 185px;
  margin-bottom: -110px;
}
.titulo {
  font-family: "Poppins";
  font-weight: 600;
  font-size: 20px;
  line-height: 30px;
  color: #1b2963;
  text-align: left;
  padding-left: 30px;
  padding-top: 70px;
  margin-bottom: 20px;
}

.contexto {
  font-family: Poppins;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  text-align: left;
  padding-left: 40px;
  padding-right: 25%;
  white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 15ch;
}
.enlace {
  font-family: "Yusei-magic";
  text-align: end;
  font-size: 20px;
  color: #000d5a;
  font-weight: 600;
  background-color: transparent;
  border: transparent;
  float: right;
  margin-top: 15px;
}
.enlacepdf {
  color: cadetblue;
}
@media (max-width:1500px) {
 .contexto{
   max-width: 75ch ;
 } 
}
@media (max-width: 1024px) {
  .contexto {
    padding: 0 5% 0 5%;
  }
}
@media (max-width:768px) {
  .cards {
    width: 36vw !important;
  }
}
.el-carousel__item h3 {
  color: #475669;
  font-size: 14px;
  opacity: 0.75;
  line-height: 150px;
  margin: 0;
}
@media (max-width:500px) {
  .cards{
    width: 100%!important;
  }
  .contexto{
      max-width: 25ch;
  }
  .el-carousel__item.is-active {
    margin-left: 9% !important;

  }
  #mat{
    margin-top: 30px;
  }
}

</style>